import * as React from 'react';
import { GridRowsImage } from './components/GridRowsImage';

export const LoadingOverlay = () => {
  return (
    <>
      <GridRowsImage label="Loading..." />
    </>
  );
};
